<div class="floating-basket"
     [class.empty]="itemCount === 0 && mode === 'cleaning'"
     [class.creating]="creatingWorkflow"
     [class.configuration-mode]="mode === 'configuration'">
  <div class="basket-bar">
    <div class="basket-info" *ngIf="mode === 'cleaning'">
      <!-- Icon: flag or spinner -->
      <mat-icon *ngIf="!creatingWorkflow" class="basket-icon" svgIcon="flag"></mat-icon>
      <mat-icon *ngIf="creatingWorkflow" class="basket-icon spinner">autorenew</mat-icon>
      
      <!-- Label: Issues to Fix or Creating Workflow -->
      <span class="basket-label">{{ creatingWorkflow ? 'Creating Workflow' : 'Selected Fixes' }}</span>
      
      <!-- Count display -->
      <span class="basket-count" *ngIf="!creatingWorkflow">
        {{ itemCount }}/{{ totalCount }}
      </span>
      
      <!-- Progress display -->
      <span class="basket-count" *ngIf="creatingWorkflow && workflowProgress">
        {{ workflowProgress.current }}/{{ workflowProgress.total }} goals created
      </span>
      <span class="basket-count" *ngIf="creatingWorkflow && !workflowProgress">
        Initializing...
      </span>
      
      <!-- Select All button moved next to count -->
      <button mat-stroked-button (click)="onSelectAll()" [disabled]="itemCount === totalCount || creatingWorkflow" class="select-all-compact">
        <mat-icon>select_all</mat-icon>
        Select All
      </button>
      
      <!-- Severity summary (hidden during creation) -->
      <div class="severity-summary" *ngIf="itemCount > 0 && !creatingWorkflow">
        <div class="severity-item" *ngIf="highSeverityCount > 0">
          <span class="severity-badge">High</span>
          <span class="severity-count">{{ highSeverityCount }}</span>
        </div>
        <div class="severity-item" *ngIf="mediumSeverityCount > 0">
          <span class="severity-badge">Medium</span>
          <span class="severity-count">{{ mediumSeverityCount }}</span>
        </div>
        <div class="severity-item" *ngIf="lowSeverityCount > 0">
          <span class="severity-badge">Low</span>
          <span class="severity-count">{{ lowSeverityCount }}</span>
        </div>
      </div>
    </div>

    <div class="configuration-summary" *ngIf="mode === 'configuration'">
      <div class="configuration-summary-item">
        <span class="configuration-summary-label">Selected Datasources</span>
        <span class="basket-count">{{ selectedDatasources }}</span>
      </div>
      <div class="configuration-summary-item">
        <span class="configuration-summary-label">Selected Options</span>
        <span class="basket-count">{{ selectedOptions }}</span>
      </div>
    </div>
    
    <div class="basket-actions">
      <button mat-raised-button color="primary" (click)="onStartWorkflow()"
              [disabled]="creatingWorkflow || (mode === 'cleaning' && itemCount === 0)"
              class="get-started-btn">
        <mat-icon [svgIcon]="mode === 'configuration' ? 'play_circle_white' : 'ai-scan-white'"></mat-icon>
        {{ mode === 'configuration' ? 'Start Assessment' : 'Get me Started with a Cleaning Workflow' }}
      </button>
    </div>
  </div>
  
  <!-- Progress bar (shown during workflow creation) -->
  <mat-progress-bar 
    *ngIf="creatingWorkflow" 
    [mode]="workflowProgress ? 'determinate' : 'indeterminate'"
    [value]="workflowProgress ? (workflowProgress.current / workflowProgress.total) * 100 : 0"
    class="workflow-progress-bar">
  </mat-progress-bar>
</div>
